/**
 * Created by koqiui on 2017-04-09.
 */
import {Utils, Jqext} from '../../app.base'
import {Routes, Vue, MsgBox} from '../../app.vues';

import SwbMerchantRealComListSelect from './MerchantRealComListSelect'
Vue.regist(SwbMerchantRealComListSelect);

/** 商户实体公司通用选择 */
export function selectMerchantRealComDlg(params, callbackFunc) {
    let theDlg = Vue.$showDialog({
        title: "商户实体公司-选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-merchant-real-com-list-select :bizUnitId="bizUnitId" :deprFlag="deprFlag" :merchantId="merchantId" :merchantType="merchantType" ref="swb_real_com_select"></swb-merchant-real-com-list-select>',
        data: {
            bizUnitId: params['bizUnitId'] || null,
            merchantId: params['merchantId'] || null,
            merchantType: params['merchantType'] || null,
            deprFlag: params['deprFlag'] == null ? null : Utils.isTrue(params['deprFlag'])
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_real_com_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbRealSignGroupListSelect from './RealSignGroupListSelect'
Vue.regist(SwbRealSignGroupListSelect);

/** 签约组/合同适用范围 选择 */
export function realSignGroupListSelectDlg(params, callbackFunc) {
    let theDlg = Vue.$showDialog({
        title: "合同适用范围 - 选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-real-sign-group-list-select :realComId="realComId" :checkBox="checkBox" :checkedIds="checkedIds" ref="swb_real_sign_group_select"></swb-real-sign-group-list-select>',
        data: {
            realComId: params['realComId'] || null,
            checkBox: params['checkBox'] || false,
            checkedIds: params['checkedIds'] || [] // 回显数据
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_real_sign_group_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbRealSignDetail from './RealSignDetail'
Vue.regist(SwbRealSignDetail);

/** 实体签约公司 */
export function realSignDetailDlg(groupId) {
    let theDlg = Vue.$showDialog({
        title: "合同适用范围 - 查看",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-real-sign-group-detail :groupId="groupId" ref="swb_real_sign_group_detail"></swb-real-sign-group-detail>',
        data: {
            groupId: groupId
        },
        okClicked: function () {
        }
    });
}


import SwbRealAdoptedComListSelect from './RealAdoptedComListSelect';

Vue.regist(SwbRealAdoptedComListSelect);

/** 入围供方公司通用选择 */
export function selectRealAdoptedComDlg (params, callbackFunc) {
    let filter = params.filter || {};
    let peerMerchantType = filter.peerMerchantType || getEnumInfoWith('merchantType', 'name', 'Vendor').value;
    let servicerType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
    let title = '入选供方公司-选择';
    if (peerMerchantType == servicerType) {
        title = '入选服务公司-选择';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-real-adopted-com-list-select :checkBox="checkBox" :checkedIds="checkedIds" :peerMerchantType="peerMerchantType" :filter="filter" ref="swb_real_adopted_com_select"></swb-real-adopted-com-list-select>',
        data: {
            checkBox: params.checkBox,
            checkedIds: params.selectIds,
            peerMerchantType: peerMerchantType,
            filter: filter
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_real_adopted_com_select.getDlgResult() || {}
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/realCom/dialog.js
// module id = 173
// module chunks = 0